(() => {
 function init(root = document) {
  root.querySelectorAll('[data-product]').forEach(product => {
   if (product.dataset.ready) return;
   product.dataset.ready = 'true';
   const select = product.querySelector('[data-variant]');
   if (!select) return;
   select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    product.querySelector('[data-price]').textContent = option.dataset.price;
    const add = product.querySelector('[data-add]');
    add.disabled = option.dataset.available !== 'true';
    add.textContent = add.disabled ? 'Tükendi' : 'Sepete ekle';
    const quantity = product.querySelector('[data-quantity]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
    const target = option.dataset.media;
    if (target) product.querySelector(`[data-media-id="${target}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
   });
  });
 }
 document.querySelectorAll('select[data-default]').forEach(select => {const option = Array.from(select.options).find(option => option.value === select.dataset.default || option.textContent === select.dataset.default); if(option) option.selected = true;});
 init(); document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('click', event => {const menu = document.querySelector('.mobile-menu[open]'); if(menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;});
 document.addEventListener('keydown', event => {if(event.key === 'Escape'){const menu=document.querySelector('.mobile-menu[open]'); if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
})();
